import PropTypes from "prop-types";
import { Header, Footer } from "../../components/index";
import "fontsource-roboto";

export default function Layout({ children, email }) {
  return (
    <div className="layout">
      <Header email={email} />
      <div className="container">{children}</div>
      <Footer />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.element.isRequired,
};
